/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CoachStopWithCoach = {
    properties: {
        coach_id: {
            type: 'number',
            isRequired: true,
        },
        coach: {
            type: 'any-of',
            contains: [{
                type: 'CoachSmall',
            }, {
                type: 'null',
            }],
        },
    },
} as const;
